import React, { Component } from 'react';
import Footer from './Footer';
import Modal from '../Common/Modal';
import Auth from '../Auth/index';
import config from '../../config'
import TokenManager from '../Auth/TokenManager';
import WithUserHeaderInfo from '../Auth/WithUserHeaderInfo';
import NavbarManager from '../Nav/NavbarManager';
import { willHideOnEditor } from '../Common/Editor/Editor';
import WithHelmet from '../Common/Helmet/WithHelmet';
import WithStoreDetail from '../Common/Providers/WithStoreDetail';
import WithDataLayerStoreDetail from '../Common/GTM/WithDataLayerStoreDetail';
import { structuredData } from '../Common/SEO/structuredData';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { getStoreLanguages } from '../Common/Providers/StoreLanguagesApi';
import { getLocalisedPath, isDefaultLanguage, isValidLanguage } from '../Common/Translations';
import { getUseableLangCode, getDefaultLanguage } from '../Locale/Locale';
import DealMenu from '../Promotion/DealMenu';
import { willShowOnRecommend, undecorated as Ribbon } from '../Ribbon/Ribbon';
import { urlParamsChecker } from '../Common/Helpers/SetCookiesHelper';
import { getConfigValue } from '../Common/Providers/ConfigsApi'

const NavbarManagerWillHideOnEditor = willHideOnEditor(NavbarManager);
const FooterWillHideOnEditor = willHideOnEditor(Footer);

const StoreRecommendRibbon = willShowOnRecommend(Ribbon);

class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBarOpen: false,
      languages: getStoreLanguages(config.storeCode),
      language: getUseableLangCode(config.storeCode),
      shouldPushHeaderDown: false,
      headerTopPx: 0,
      urlParams: queryString.parse(window.location.search),
    }
  }

  componentWillMount() {
    urlParamsChecker(this.state.urlParams);
    this.dispatchReduxStuff();
    if (this.considerRedirect()) {
      if (this.state.urlParams.retry) {
        window.location.pathname = '/404.html';
        return;
      } else { //give a chance to retry after letting editor module links to be fetched upon TTL is over
        setTimeout(() => {
          window.location.search += window.location.search ? '&retry=1' : '?retry=1';
        }, 1500);
        return;
      }
    } else {
      const path = getLocalisedPath(this.state.language, isDefaultLanguage(this.state.language));
      this.props.router.push("/" + path);
    }
  }

  componentDidMount() {
    $('.dropdown-toggle').megaMenu && $('.dropdown-toggle').megaMenu({ container: '.mmd' });
    if (!document.body.classList.contains('webapp') && localStorage.getItem('PhotobookApp')) {
      document.body.classList.add('webapp');
    }

    const checkNetcoreSticky = () => {
      const ncElementStickyElement = document.getElementById('st_notification_sticky');
      const shouldPushHeaderDown = !!ncElementStickyElement && ncElementStickyElement.children.length;
      let headerTopPx = 0;
      if (shouldPushHeaderDown) {
        headerTopPx = document.getElementById('preview-notification-frame').offsetHeight
      }
      this.setState({
        shouldPushHeaderDown: shouldPushHeaderDown,
        headerTopPx: headerTopPx
      });
    }

    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: true
    };

    const observer = new MutationObserver(checkNetcoreSticky);
    observer.observe(document.body, observerConfig);
  }

  toggleSidebar = () => {
    this.setState({
      sideBarOpen: !this.state.sideBarOpen,
    });
  }

  overlayClickHandler = () => {
    this.setState({
      sideBarOpen: false,
    });
  }

  dispatchReduxStuff = () => {
    this.props.langCode(this.state.language);
    this.props.defaultLangCode(getDefaultLanguage(this.state.languages));
    /**
     * TODO:
     * 1) Make Backend Config values Standard JSON as it's not really the case right now even though JSON.parse has no problem with it.
     * 2) Create endpoint to retrieve all configs.
     * 3) Use ajs with preprocessor to inject defaults by deployment time.
     * 4) Separate backend API call in a file that use local storage with TTL, falling back to deployment const just like editor modules.
     * 5) Refactor all getConfigValue usages to use that file
     * */
    getConfigValue('facebook-integration').then((data) => {
      this.props.backendConfig({
        facebookIntegrationEnabled: JSON.parse(data).enabled
      })
    })

    getConfigValue('paypal-pay-later').then((data) => {
      this.props.setPaypalPayLater(JSON.parse(data))
    });

    getConfigValue('ab.feature').then((data) => {
      this.props.setAbFeatureConfig(JSON.parse(data))
    });
  }

  considerRedirect = () => {
    //React routes are funny, the id (aka language code for us) is only matched correctly with proper routes
    //In other words, if the route is a valid one, the id would be a language code or undefined
    //if a random non-existing route is presented, the clue for us is that it does not match a valid language code
    const langFromPath = this.props.params.id;
    const isErrorRoute = langFromPath && !isValidLanguage(langFromPath);
    const isResolvedLangWrong = !isValidLanguage(this.state.language);
    return isErrorRoute || isResolvedLangWrong;
  }

  render() {
    let overlay = { display: this.state.sideBarOpen ? 'block' : 'none' };
    const pushDownStyle = this.state.shouldPushHeaderDown ? {marginTop: this.state.headerTopPx + 'px'} : {};

    return (
      <div>
        <Helmet>
          <script type="application/ld+json">{structuredData()}</script>
        </Helmet>
        <TokenManager>
          {(state, methods) => (
            <div>
              <WithHelmet {...this.props} />
              <StoreRecommendRibbon languages={this.state.languages} />
              <WithUserHeaderInfo {...this.props} />
              <WithStoreDetail />
              <WithDataLayerStoreDetail />
              <header className="header__nav" style={pushDownStyle}>
                <NavbarManagerWillHideOnEditor
                  sideBarOpen={this.state.sideBarOpen}
                  toggleSidebar={this.toggleSidebar}
                  languages={this.state.languages}
                  shouldPushHeaderDown={this.state.shouldPushHeaderDown}
                  headerTopPx={this.state.headerTopPx}
                  {...this.props}
                />
                <div
                  className="mmm__overlay"
                  onClick={this.overlayClickHandler}
                  style={overlay}
                />
                <div
                  className="mmm__overlay--hidenav"
                  onClick={this.overlayClickHandler}
                  style={overlay}
                />
                <DealMenu/>
              </header>
              <main style={{ minHeight: '100vh' }}>{this.props.children}</main>
              <Modal modalId="modal-account" size="md">
                {(closeModal) => (
                  <Auth
                    closeModal={closeModal} />
                )}

              </Modal>
              {!this.props.location.pathname.includes('/checkout') && <FooterWillHideOnEditor languages={this.state.languages}/>}
            </div>
          )
          }
        </TokenManager>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    langCode: (lang) => dispatch({ type: 'SET_LANGUAGE', payload: lang }),
    defaultLangCode: (defaultLang) => dispatch({ type: 'SET_DEFAULT_LANGUAGE', payload: defaultLang }),
    backendConfig: (payload) => dispatch({type: 'SET_BACKEND_CONFIG', payload: payload}),
    setPaypalPayLater: (payload) => dispatch({type: 'SET_PAYPAL_PAY_LATER', payload: payload}),
    setAbFeatureConfig: (payload) => dispatch({ type: 'SET_AB_FEATURE_CONFIG', payload: payload }),
  }
}

export default connect(null, mapDispatchToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/Layout/Main.js